import SettingsOutlined from "@mui/icons-material/SettingsOutlined";
import { Box, IconButton, SvgIcon, Typography } from "@mui/material";
import { useDialog } from "../../utils/hooks/use-dialog";
import { TagsDialog } from "./tags-dialog";

import type { FC } from "react";

export const TagsFilter: FC = () => {
  const { open, handleOpen, handleClose } = useDialog();

  return (
    <>
      <Box sx={{ mb: 3, display: "flex", alignItems: "center", gap: 1 }}>
        <Typography variant="body1" sx={{ fontWeight: 700 }}>
          Tags
        </Typography>
        <IconButton data-analytics-id="tags-settings" onClick={handleOpen} size="small">
          <SvgIcon data-testid="settings-menu-chevron" fontSize="small">
            <SettingsOutlined />
          </SvgIcon>
        </IconButton>
      </Box>
      <TagsDialog open={open} handleClose={handleClose} />
    </>
  );
};
